module.exports = __webpack_public_path__ + "img/NO953299216.4572bdd1.svg";